export default __webpack_public_path__ + "media/images/clippy_wave-08dd77627aebc3a03c6144aa032a16ce.gif";